(function( $ ) {
  'use strict';

  $(window).load(function () {
    $(".info_flow").each(function () {
      const sections = $(this).find(".info_flow_section");

      if ($(window).width() > 800) {
        const maxHeight = Math.max.apply(
          null,
          sections.map(function () {
            return $(this).outerHeight();
          })
        );

        sections.css("height", `${maxHeight}px`);
      }

      sections.waypoint({
        handler: function () {
          $(this.element).css("opacity", 1);
        },
        offset: "50%"
      });
    });
  });
})( jQuery );
